import { userState } from '@hefe/store';
import { Col, Empty, Row } from 'antd';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import CustomList from '../../../core/components/custom-list/custom-list.component';
import EventDateBoxComponent from '../event-date-box/event-date-box.component';
import UserEventListItem from '../list-items/user-event-list-item';

export default function UpcomingUserEventsComponent() {
  const user = useSelector(userState).user;

  const events = user?.basketball_user?.upcomingEvents;
  let eventsArray: any[] = [];
  if (events) {
    eventsArray = _.keys(events).map((date: any) => {
      return {
        date: date,
        events: events[date],
      };
    });
  }

  if (eventsArray.length === 0) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
  }

  return (
    <CustomList
      itemLayout="horizontal"
      dataSource={eventsArray}
      renderItem={(item: any, i) => {
        const items: any[] = [];
        for (const event of item.events) {
          items.push(<UserEventListItem event={event} key={i} />);
        }

        return (
          <Row style={{ marginBottom: 10 }}>
            <Col md={3} sm={24}>
              <EventDateBoxComponent date={item.date} />
            </Col>
            <Col md={21} sm={24}>
              {items}
            </Col>
          </Row>
        );
      }}
    />
  );
}
